// Definición de defaults

export const defaultTipoSentencia: TipoSentenciaProps = {
    idTipoSentencia:    0,
    descripcion:        '',
    activo:             false,
};

// Creación de interfaces

export interface TipoSentenciaProps   {
    idTipoSentencia:    number;
    descripcion:        string;
    activo:             boolean;
}